import * as Yup from 'yup';

export const feedbackValidator = () =>
  Yup.object().shape({
    topic: Yup.string().required('Required'),
    message: Yup.string().required('Required').min(10, 'Must be at least 10 characters').max(1000, 'Must be at most 1000 characters'),
    marketingConsent: Yup.boolean().required(),
  });
